import { render, staticRenderFns } from "./Finder.vue?vue&type=template&id=0bea3fa6"
import script from "./Finder.vue?vue&type=script&lang=js"
export * from "./Finder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports